import { useGLTF } from "@react-three/drei";
import { GroupProps } from "@react-three/fiber";
import { useEffect } from "react";

export type ScreenProps = {} & GroupProps;

const Screen = (props: ScreenProps) => {
  const screen = useGLTF("/models/screen.glb");

  useEffect(() => {
    screen.scene.traverse((child) => {
      child.castShadow = true;
      child.receiveShadow = true;
    });
  }, [screen]);

  return (
    <group {...props}>
      <primitive object={screen.scene} castShadow receiveShadow />
    </group>
  );
};

useGLTF.preload("/models/screen.glb");

export default Screen;
